module.exports = __webpack_public_path__ + "static/media/zllc1_en.5c27e1ee.png";